import { render, staticRenderFns } from "./UserDocumentCreateModal.vue?vue&type=template&id=2064dda2&scoped=true&"
import script from "./UserDocumentCreateModal.vue?vue&type=script&lang=js&"
export * from "./UserDocumentCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDocumentCreateModal.vue?vue&type=style&index=0&id=2064dda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064dda2",
  null
  
)

export default component.exports